module.exports = __webpack_public_path__ + "img/o2spa-office.673f45de.jpg";